/**
 * Initialization for Bootstrap tooltips.
 *
 * @link https://getbootstrap.com/docs/3.3/javascript/#tooltips
 */

jQuery(function ($) {
    $('[data-toggle="tooltip"]').tooltip()
});
